import React, { useCallback, useState } from "react";

type ScrollableProps = React.PropsWithChildren<{
  onReachBottom?: () => void;
}>;

export const Scrollable = React.memo<ScrollableProps>((props) => {
  const { onReachBottom } = props;
  // ensures that onReachBottom only gets called once
  const [hasInvokedCallback, setHasInvokedCallback] = useState(false);

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
      const isAtBottom = Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1;
      if (isAtBottom && !hasInvokedCallback) {
        setHasInvokedCallback(true);
        onReachBottom?.();
      }
    },
    [hasInvokedCallback, onReachBottom],
  );

  return (
    <div
      className="max-h-[400px] overflow-y-auto rounded-xl border border-grey px-6 py-7 md:max-h-[500px]"
      onScroll={handleScroll}
    >
      {props.children}
    </div>
  );
});

Scrollable.displayName = "Scrollable";
